import { SearchIsland } from '@rocco/ui/floating-island/components/SearchIsland';
import { useSearchInput } from '@rocco/ui/search/hooks/use-search-input';
import type { SearchIndexes } from '@modules-rocco/search/types/enum/search-indexes';
import { useCategorySearch } from '@ui-rocco/hooks/use-category-search';
import type { DisplayMode } from '@rocco/types/enum/display-mode';
import { useAtom } from 'jotai';
import { uiStateAtomSearchModalOpened } from '~/modules-rocco/search/states/ui-state-search-modal-opened';

interface CategorySearchIslandProps {
    searchIndex?: SearchIndexes;
    placeholders?: string[];
    displayMode: DisplayMode;
    initialQuery?: string;
    toggleSearchModalOnClick?: boolean;
    scrollThreshold?: number;
    shouldAutoFocusOnVisible?: boolean;
}

export function CategorySearchIsland({
    searchIndex,
    placeholders,
    displayMode,
    initialQuery,
    toggleSearchModalOnClick = false,
    scrollThreshold = 200,
    shouldAutoFocusOnVisible = false,
}: CategorySearchIslandProps) {
    const { query, handleSearch } = useCategorySearch(initialQuery);

    const searchInput = useSearchInput({
        query,
        searchIndex,
        disableSuggestions: true,
        doSearch: handleSearch,
    });

    const [, setSearchModalOpened] = useAtom(uiStateAtomSearchModalOpened);

    const shouldToggleSearchModalOnClick =
        displayMode === 'mobile' && toggleSearchModalOnClick;

    return (
        <SearchIsland
            input={searchInput}
            placeholderTexts={
                placeholders ?? [
                    'Search Professional, Products, Project and Articles...',
                ]
            }
            displayMode={displayMode}
            onClick={
                shouldToggleSearchModalOnClick
                    ? () => setSearchModalOpened(true)
                    : undefined
            }
            scrollThreshold={displayMode === 'mobile' ? 0 : scrollThreshold}
            autoFocusOnVisible={shouldAutoFocusOnVisible}
        />
    );
}
